import { render, staticRenderFns } from "./NationalityModal.vue?vue&type=template&id=20dc4366"
import script from "./NationalityModal.vue?vue&type=script&lang=js"
export * from "./NationalityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports